"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.devMode = exports.userReducer = exports.clearSession = exports.setPaymentEngineToken = exports.setMediaUploadToken = exports.setClientToken = exports.setUserToken = exports.setIsLoading = exports.setUser = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var devMode = process.env.NODE_ENV !== "production";
exports.devMode = devMode;
var initialState = {
    user: {
        username: devMode ? "Fred" : "",
        email: devMode ? "fred@doshex.com" : "",
        cell_number: devMode ? "0837983429" : "",
        password: devMode ? "0000" : "",
        confirm_password: devMode ? "0000" : "",
        name: devMode ? "Fred" : "",
        surname: devMode ? "Moller" : "",
        reset_password_otp: undefined,
        remember_me: true,
        birthday: devMode ? "11/25/1991" : undefined,
        client_id: "",
        payment_engine_id: "",
        agrees_terms_and_conditions: devMode && true,
    },
    token: "",
    client_token: "",
    media_upload_token: "",
    payment_engine_token: "",
    isLoading: false,
};
var slice = (0, toolkit_1.createSlice)({
    name: "user",
    initialState: initialState,
    reducers: {
        setUser: function (state, action) {
            state.user = action.payload;
        },
        setIsLoading: function (state, action) {
            state.isLoading = action.payload;
        },
        setUserToken: function (state, action) {
            state.token = action.payload;
        },
        setClientToken: function (state, action) {
            state.client_token = action.payload;
        },
        setMediaUploadToken: function (state, action) {
            state.media_upload_token = action.payload;
        },
        setPaymentEngineToken: function (state, action) {
            state.payment_engine_token = action.payload;
        },
        // initialState seeds a dev fixture user, so resetting to it would sign the operator into that account instead of out
        clearSession: function () { return (__assign(__assign({}, initialState), { user: {}, token: "", client_token: "", media_upload_token: "", payment_engine_token: "" })); },
    },
});
var _a = slice.actions, setUser = _a.setUser, setIsLoading = _a.setIsLoading, setUserToken = _a.setUserToken, setClientToken = _a.setClientToken, setMediaUploadToken = _a.setMediaUploadToken, setPaymentEngineToken = _a.setPaymentEngineToken, clearSession = _a.clearSession;
exports.setUser = setUser;
exports.setIsLoading = setIsLoading;
exports.setUserToken = setUserToken;
exports.setClientToken = setClientToken;
exports.setMediaUploadToken = setMediaUploadToken;
exports.setPaymentEngineToken = setPaymentEngineToken;
exports.clearSession = clearSession;
var userReducer = slice.reducer;
exports.userReducer = userReducer;
